import Vue from "vue";
import VueRouter from "vue-router";
import Index from "@/views/Index.vue";
import AuthGuard from './auth-guard';

const Checkout = () => import("../views/Checkout.vue");
const ResetPasswordForm = () => import("../views/ResetPassword.vue");
const AccountActivated = () => import("../views/AccountActivated.vue");
const ThankYou = () => import("../views/ThankYou.vue");
const Login = () => import("../views/Login.vue");
const SignUpFree = () => import("../views/SignUpFree.vue");
const ForgotPassword = () => import("../views/ForgotPassword.vue");
const ResetFeedback = () => import("../views/ResetFeedback.vue");
const MyAccount = () => import("../views/private/my-account/MyAccount.vue");
const BogoCheckout = () => import("../views/Bogo.vue");
const BrandCheckout = () => import("../views/Brand.vue");
const HappyHolidays = () => import("../views/HappyHolidays.vue");
const SeventeenMonths = () => import("../views/SeventeenMonths.vue");
const PowerDrops = () => import("../views/PowerDrops.vue");
const NextLevelPowerDrops = () => import("../views/NextLevelPowerDrops.vue");
const NextLevelWithoutDS = () => import("../views/NextLevelWithoutDS.vue");
const AromaEmpress = () => import("../views/AromaEmpress.vue");
const NextLevelAromaEmpress = () => import("../views/NextLevelAromaEmpress.vue");
const MelaniMethodOffer = () => import("../views/MelaniMethodOffer.vue");
const EOArchitectureWorkshop = () => import("../views/EOArchitectureWorkshop.vue");
const EOEmpress = () => import("../views/EOEmpress.vue");
const RealRecipes = () => import("../views/RealRecipes.vue");
const Deluxe = () => import("../views/Deluxe.vue");
const FormulatingFoundations = () => import("../views/FormulatingFoundations.vue");
const ChallengeOffer = () => import("../views/ChallengeOffer.vue");
const AromaAlphabet = () => import("../views/AromaAlphabet.vue");
const SpeedStart = () => import("../views/SpeedStart.vue");
const AustraliaConf = () => import("../views/AustraliaConf.vue");
const Upsell = () => import("../views/Upsell.vue");
const SignUpTrial = () => import("../views/SignUpTrial.vue");
const AdvancedTraining = () => import("../views/AdvancedTraining.vue");
const MyPremiumMaterial = () => import("../views/private/my-premium-material/MyPremiumMaterial.vue");
const FriendReferrals = () => import("../views/private/friend-referrals/FriendReferrals.vue");
const OldPerks = () => import("../views/private/perks/Perks.vue");
const DropsmartMarketplace = () => import("../views/marketplace/DropsmartMarketplace.vue");
const DropsmartCentre = () => import("../views/centre/DropsmartCentre.vue");
const Perks = () => import("../views/centre/perks/Perks.vue");
const Expo = () => import("../views/centre/expo/Expo.vue");
const App = () => import("../views/centre/app/App.vue");
const Academy = () => import("../views/centre/academy/Academy.vue");
const Premium = () => import("../views/centre/premium/Premium.vue");
const LiveQA = () => import("../views/centre/liveqa/LiveQA.vue");
const FreeUser = () => import("../views/centre/free-user/FreeUser.vue");
const Referral = () => import("../views/centre/referral/Referral.vue");
const CentreMyAccount = () => import("../views/centre/my-account/CentreMyAccount.vue");

Vue.use(VueRouter);

const routes = [
  {
    path: "/indexpath",
    name: "IndexPath",
    component: Index,
  },
  {
    path: "/",
    name: "Index",
    component: Checkout,
  },
  
  // CHECKOUT PAGES SECTION
  {
    path: "/nextlevel",
    name: "NextLevelPowerDrops",
    component: NextLevelPowerDrops,
    props: _route => {
      _route;
      return { combos: [29], includeSubscription: true };
    },
  },
  {
    path: "/nextlevelspecial",
    name: "NextLevelWithoutDS",
    component: NextLevelWithoutDS,
    props: _route => {
      _route;
      return { combos: [59], includeSubscription: false };
    },
  },  
  {
    path: "/melanimethod",
    name: "MelaniMethodOffer",
    component: MelaniMethodOffer,
    props: _route => {
      _route;
      return { combos: [19] };
    },
  },
  {
    path: "/eoaworkshop",
    name: "EOArchitectureWorkshop",
    component: EOArchitectureWorkshop,
    props: _route => {
      _route;
      return { combos: [57], includeSubscription: true };
    },
  },
  {
    path: "/eoe",
    name: "EOEmpress",
    component: EOEmpress,
    props: _route => {
      _route;
      return { combos: [58], includeSubscription: true };
    },
  },
  {
    path: "/aromaempress",
    name: "AromaEmpress",
    component: AromaEmpress,
    props: _route => {
      _route;
      return { combos: [11] };
    },
  },
  {
    path: "/nlae",
    name: "NextLevelAromaEmpress",
    component: NextLevelAromaEmpress,
    props: _route => {
      _route;
      return { combos: [54] };
    },
  },
  {
    path: "/brand",
    name: "BrandCheckout",
    props: _route => {
      _route;
      return { combos: [32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51] };
    },
    component: BrandCheckout,
  },
  {
    path: "/checkout",
    name: "Checkout",
    alias: ["/premium"],
    component: Checkout,
  },

  // AUTHENTICATION PAGES SECTION
  {
    path: "/password-recovery-form",
    name: "ResetPassword",
    component: ResetPasswordForm,
    props: route => {
      return { token: route.query.token };
    }
  },
  {
    path: "/account-activated",
    name: "AccountActivated",
    component: AccountActivated,
  },
  {
    path: "/thank-you",
    name: "ThankYou",
    component: ThankYou,
    props: true,
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    path: "/sign-up",
    alias: ["/signup", "/sign-up-free", "/signup-free", "/signupfree", "/free", "/freeaccess", "/free-access"],
    name: "SignUpFree",
    redirect: '/signup-trial',
    component: SignUpFree,
  },
  {
    path: "/forgot-password",
    alias: ["/forgot", "/forgotpassword"],
    name: "ForgotPassword",
    component: ForgotPassword,
  },
  {
    path: "/reset-feedback",
    name: "ResetFeedback",
    component: ResetFeedback,
    props: true,
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Login,
  },

  // OLD CHECKOUT PAGES SECTION - Marked with Redirect

  {
    path: "/deluxe",
    name: "Deluxe",
    redirect: '/',
    component: Deluxe,
  },  
  {
    path: "/powerdrops",
    name: "PowerDrops",
    redirect: '/',
    component: PowerDrops,
    props: _route => {
      _route;
      return { combos: [29, 30] };
    },
  },  
  {
    path: "/realrecipes",
    name: "RealRecipes",
    redirect: '/',
    component: RealRecipes,
    props: _route => {
      _route;
      return { combos: [12] };
    },
  },
  {
    path: "/formulatingfoundations",
    name: "FormulatingFoundations",
    redirect: '/',
    component: FormulatingFoundations,
    props: _route => {
      _route;
      return { combos: [17, 18] };
    }
  },
  {
    path: "/joinsmartblending",
    name: "SmartBlending",
    alias: ["/smartblending"],
    redirect: '/',
    component: ChallengeOffer,
    props: _route => {
      _route;
      return { p: Number(_route.query.p) };
    }
  },
  {
    path: "/aromaalphabet",
    name: "AromaAlphabet",
    redirect: '/',
    component: AromaAlphabet,
    props: _route => {
      _route;
      return { combos: [19] };
    }
  },
  {
    path: "/speedstartgift",
    name: "SpeedStartGift",
    redirect: '/',
    component: SpeedStart,
    props: _route => {
      _route;
      return { combos: [20, 26], upsellCombo: [26], includeSubscription: false };
    }
  },
  {
    path: "/speedstart",
    name: "SpeedStart",
    redirect: '/',
    component: SpeedStart,
    props: _route => {
      _route;
      return { combos: [27, 28], upsellCombo: [28], includeSubscription: true };
    }
  },
  {
    path: "/bonus",
    name: "AustraliaConf",
    redirect: '/',
    component: AustraliaConf,
    props: _route => {
      _route;
      return { combos: [22] };
    }
  },
  {
    path: "/gift",
    name: "Gift",
    component: Checkout,
    redirect: '/',
  },
  {
    path: "/bonusclass",
    name: "BonusClass",
    redirect: '/',
    component: Checkout,
  },
  {
    path: "/gift-card",
    alias: ["/holidaygift-gratitude", "/holidaygift-inspiration", "/holidaygift-contentment", "/holidaygift-fulfillment", "/holidaygift-success", "/holidaygift-serenity", "/holidaygift-peacefulness", "/holidaygift-delight", "/holidaygift-cheer", "/holidaygift-bliss", "/holidaygift-felicity", "/holidaygift-glee", "/holidaygift-fun", "/holidaygift-joy", "/holidaygift-respect", "/holidaygift-acknowledgment", "/holidaygift-thanks", "/holidaygift-gratefulness", "/holidaygift-happiness", "/holidaygift-appreciation"],
    name: "GiftCard",
    redirect: '/',
    component: Checkout,
  },
  {
    path: "/twodayoffer",
    name: "TwoDayOffer",
    redirect: '/',
    component: Checkout,
  },

  // Marketplace
  {
    path: "/marketplace",
    name: "DropsmartMarketplace",
    component: DropsmartMarketplace,
    props: true,
  },

  // Private area - only for logged in users
  {
    path: "/private",
    name: "PrivateDefault",
    component: MyAccount,
    beforeEnter: AuthGuard,
  },
  {
    path: "/private/my-account",
    name: "MyAccount",
    component: MyAccount,
    beforeEnter: AuthGuard,
    props: true,
  },
  {
    path: "/private/my-premium-material",
    name: "MyPremiumMaterial",
    component: MyPremiumMaterial,
    beforeEnter: AuthGuard,
    props: route => {
      return { stepQuery: route.query.step };
    },
  },
  {
    path: "/private/friend-referrals",
    name: "FriendReferrals",
    component: FriendReferrals,
    beforeEnter: AuthGuard,
    props: true,
  },
  {
    path: "/private/products/oldperks",
    name: "OldPerks",
    component: OldPerks,
    beforeEnter: AuthGuard,
    props: true,
  },
  {
    // /:bogoType(mb|yb|eoas) -> matches both mb to monthly bogo or yb to yearly bogo
    path: "/:bogoType(mb|yb|eoas)",
    name: "Bogo",
    //uncomment the following line if the the bogo was deactivated
    // redirect: '/',
    component: BogoCheckout,
    props: true,
  },
  {
    path: "/30off",
    name: "HappyHolidays",
    component: HappyHolidays,
    props: _route => {
      _route;
      return { combos: [8] };
    }
  },
  {
    path: "/17m",
    name: "SeventeenMonths",
    component: SeventeenMonths,
    props: _route => {
      _route;
      return { combos: [5] };
    }
  },
  {
    path: "*",
    name: "Default",
    component: Login,
  },
  {
    path: "/oto",
    name: "Upsell",
    redirect: '/',
    props: true,
    component: Upsell,
  },
  {
    path: "/signup-trial",
    name: "SignUpTrial",
    props: true,
    component: SignUpTrial,
  },
  {
    path: "/bundle",
    name: "AdvancedTraining",
    component: AdvancedTraining,
    props: _route => {
      _route;
      return { combos: [31], includeSubscription: true };
    }
  },
  // Centre Area - only logged users
  {
    path: "/center",
    name: "DropsmartCentre",
    props: true,
    component: DropsmartCentre, Expo,
    beforeEnter: AuthGuard,
    children: [
      {
        path: "/center/expo",
        name: "Expo",
        // props: true,
        component: DropsmartCentre, Expo,
        beforeEnter: AuthGuard,
        props: route => {
          return { category: route.query.category, id: route.query.id };
        },
      },
      {
        path: "/center/perks",
        name: "Perks",
        // props: true,
        component: DropsmartCentre, Perks,
        beforeEnter: AuthGuard,
        props: route => {
          return { category: route.query.category, id: route.query.id };
        },
      },
      {
        path: "/center/app",
        name: "App",
        props: true,
        component: DropsmartCentre, App,
        beforeEnter: AuthGuard,
      },
      {
        path: "/center/academy",
        name: "Academy",
        // props: true,
        component: DropsmartCentre, Academy,
        beforeEnter: AuthGuard,
        props: route => {
          return { category: route.query.category, step: route.query.step };
        },
      },
      {
        path: "/center/liveqa",
        name: "LiveQA",
        // props: true,
        component: DropsmartCentre, LiveQA,
        beforeEnter: AuthGuard,
        props: route => {
          return { category: route.query.category, step: route.query.step };
        },
      },
      {
        path: "/center/premium",
        name: "Premium",
        // props: true,
        component: DropsmartCentre, Premium,
        beforeEnter: AuthGuard,
        props: route => {
          return { category: route.query.category, id: route.query.id };
        },
      },
      {
        path: "/center/free-user",
        name: "FreeUser",
        // props: true,
        component: DropsmartCentre, FreeUser,
        beforeEnter: AuthGuard,
        props: route => {
          return { category: route.query.category, id: route.query.id };
        },
      },      
      {
        path: "/center/referral",
        name: "Referral",
        props: true,
        component: DropsmartCentre, Referral,
        beforeEnter: AuthGuard,
      },
      {
        path: "/center/my-account",
        name: "CentreMyAccount",
        props: true,
        component: DropsmartCentre, CentreMyAccount,
        beforeEnter: AuthGuard,
      },
    ],
  },

];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
